import {
  NavigateOptions,
  createSearchParams,
  useNavigate
} from "react-router-dom"

import { merge } from "lodash-es"

import { PROJECT_DETAILS } from "shared/constants/permalinks"
import { useEvent } from "shared/lib/useEvent"
import { useLocale } from "shared/lib/useLocale"

export function useNavigateToProject<T extends string | null>(
  id: T,
  options?: NavigateOptions | undefined
): T extends string
  ? () => void
  : (payload?: {
      id: string
      params?: Record<string, string> | null
      options?: NavigateOptions | undefined
    }) => void
export function useNavigateToProject<T extends string | null>(
  id: T,
  options?: NavigateOptions | undefined
) {
  const navigate = useNavigate()
  const { currentLocale } = useLocale()

  return useEvent(
    (payload?: {
      id: string
      params?: Record<string, string> | null
      options?: NavigateOptions | undefined
    }) => {
      const resolvedID = id || (payload?.id ?? "")
      const pathname = `/${currentLocale}/${PROJECT_DETAILS}`

      navigate(
        {
          pathname,
          search: `?${createSearchParams({
            ...payload?.params,
            project_id: resolvedID ?? ""
          })}`
        },
        merge({}, options, payload?.options)
      )
    }
  )
}
